import { clearCachedGamesForSport } from "./header/GamesSlider.js";

/**
 * Clear sport cache via AJAX
 * Used when no athletes are found to try refreshing data
 */
export default async function ClearSportCache(sport) {
  const data = new FormData();
  data.append('action', 'clear_sport_cache');
  data.append('sport', sport);

  try {
    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: data,
    });

    // WordPress may return HTML (e.g., auth redirect) or "0" on failure.
    const contentType = response.headers.get('content-type') || '';
    let result = null;

    if (!response.ok) {
      const text = await response.text();
      console.error(`Error clearing cache: HTTP ${response.status}`, text.slice(0, 200));
      return false;
    }

    try {
      if (contentType.includes('application/json')) {
        result = await response.json();
      } else {
        const text = await response.text();
        // Try to parse a JSON-looking string; otherwise log and bail.
        try {
          result = JSON.parse(text);
        } catch (e) {
          console.error('Error clearing cache: non-JSON response', text.slice(0, 200));
          return false;
        }
      }
    } catch (parseErr) {
      console.error('Error clearing cache: failed to parse response', parseErr);
      return false;
    }

    if (result.success) {
      clearCachedGamesForSport(sport);
      console.log(`Cache cleared for ${sport}`);
      return true;
    } else {
      console.error('Error clearing cache:', result.data);
      return false;
    }
  } catch (error) {
    console.error('Error clearing cache:', error);
    return false;
  }
}
